export const formatDateDetails = (dateString: string) => {
  const date = new Date(dateString);

  return {
    Full_Date: date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }),
    Month: date.toLocaleDateString("en-US", { month: "short" }),
    Year: date.getFullYear(),
    Date: date.getDate(),
    Day: date.toLocaleDateString("en-US", { weekday: "long" }),
  };
};

export const formatFromDateDetails = (dateString: string) => {
  const date = new Date(dateString);

  return {
    From_Full_Date: date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }),
    From_Month: date.toLocaleDateString("en-US", { month: "short" }),
    From_Year: date.getFullYear(),
    From_Date: date.getDate(),
    From_Day: date.toLocaleDateString("en-US", { weekday: "long" }),
  };
};

export const formatTime = (time: string) => {
  if (time) {
    const [hours, minutes] = time?.split(":");
    let formattedTime = `${parseInt(hours) % 12 || 12}:${minutes} ${
      parseInt(hours) >= 12 ? "PM" : "AM"
    }`;
    return formattedTime;
  }
  return "N/A";
};

export const formatUrl = (url: string | undefined) => {
  if (url && !url.startsWith("https://") && !url.startsWith("http://")) {
    return `https://${url}`;
  }
  return url;
};

export const getFormattedDate = (
  addYears = 0,
  subtractDays = 0,
  subtractMonths = 0
) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + addYears);
  date.setDate(date.getDate() - subtractDays);
  date.setMonth(date.getMonth() - subtractMonths);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

// export const getMembershipExpiryStatus = (expiryDateStr: string) => {
//   if (!expiryDateStr) {
//     return {
//       label: "No Expiry",
//       color: "#6c757d",
//       bgColor: "#e0e0e0",
//     };
//   }

//   const expiryDate = new Date(expiryDateStr);
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);
//   expiryDate.setHours(0, 0, 0, 0);

//   const diffInTime = expiryDate.getTime() - today.getTime();
//   const diffInDays = Math.ceil(diffInTime / (1000 * 3600 * 24));

//   if (diffInDays < 0) {
//     return {
//       label: "Expired",
//       color: "red",
//       bgColor: "#e0e0e0",
//     };
//   } else {
//     return {
//       label: "Not expired",
//       color: "green",
//       bgColor: "#e0e0e0",
//     };
//   }
// }

export const showRenewButton = (expiryDateStr?: string): boolean => {
  if (!expiryDateStr) return false;

  const today = new Date();
  const expiryDate = new Date(expiryDateStr);
  const oneMonthFromNow = new Date();
  oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);

  return (
    expiryDate < today || (expiryDate >= today && expiryDate <= oneMonthFromNow)
  );
};

export const getMembershipStatusColor = (status?: string) => {
  switch (status) {
    case "Activate":
      return { color: "green" };
    case "Pending":
      return { color: "yellow" };
    case "Reject":
      return { color: "red" };
    case "Expire":
      return { color: "darkred" };
    default:
      return { color: "#6c757d" };
  }
};
